import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/views/export", JSONbody, {}, {
    "Accept": []
  }, requestOptions);
}
export function createForSearch(searchId, Optionaloverrides, requestOptions) {
  return __request__("POST", `/views/export/${searchId}`, Optionaloverrides, {}, {
    "Accept": []
  }, requestOptions);
}
export function createForSearchType(searchId, searchTypeId, Optionaloverrides, requestOptions) {
  return __request__("POST", `/views/export/${searchId}/${searchTypeId}`, Optionaloverrides, {}, {
    "Accept": []
  }, requestOptions);
}
